import actionTypes from "../../actionTypes";

export const unlockUserAccountLoaderAction = (data) => ({
  type: actionTypes.adminTypes.userManagementTypes.UNLOCK_USER_ACCOUNT_LOADER,
  payload: data,
});
export const toggleUserStatusLoaderAction = (data) => ({
  type: actionTypes.adminTypes.userManagementTypes.TOGGLE_USER_STATUS_LOADER,
  payload: data,
});
export const isLoginIdExistsLoaderAction = (data) => ({
  type: actionTypes.adminTypes.userManagementTypes.IS_LOGINID_EXISTS_LOADER,
  payload: data,
});
export const getCountryListLoaderAction = (data) => ({
  type: actionTypes.adminTypes.userManagementTypes.GET_COUNTRY_LIST_LOADER,
  payload: data,
});
export const getStateListLoaderAction = (data) => ({
  type: actionTypes.adminTypes.userManagementTypes.GET_STATE_LIST_LOADER,
  payload: data,
});
export const getCityListLoaderAction = (data) => ({
  type: actionTypes.adminTypes.userManagementTypes.GET_CITY_LIST_LOADER,
  payload: data,
});
export const getWorkOfficeListLoaderAction = (data) => ({
  type: actionTypes.adminTypes.userManagementTypes.GET_WORK_OFFICE_LIST_LOADER,
  payload: data,
});
export const getProductCategoryListLoaderAction = (data) => ({
  type: actionTypes.adminTypes.userManagementTypes
    .GET_PRODUCT_CATEGORY_LIST_LOADER,
  payload: data,
});
export const getUserGroupsLoaderAction = (data) => ({
  type: actionTypes.adminTypes.userManagementTypes.GET_USER_GROUPS_LOADER,
  payload: data,
});
export const getAllRolesLoaderAction = (data) => ({
  type: actionTypes.adminTypes.userManagementTypes.GET_ALL_ROLES_LOADER,
  payload: data,
});
export const postUserProfileLoaderAction = (data) => ({
  type: actionTypes.adminTypes.userManagementTypes.POST_USER_PROFILE_LOADER,
  payload: data,
});
export const putUserProfileLoaderAction = (data) => ({
  type: actionTypes.adminTypes.userManagementTypes.PUT_USER_PROFILE_LOADER,
  payload: data,
});
